
<template>
  <div class="custom-template" :style="{background:baColor}">
    <div class="info-content flex">
      <img class="left-img" :src="data.shareImageUrl" alt="" />
      <div class="info-text">{{data.shareDesc}}</div>
    </div>
  </div>
</template>
  
  <script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    baColor: {
      type: String,
      default: "linear-gradient(180deg, #EFF2FF 0%, #FDFDFD 100%)"
    }
  },
  methods: {
    joinVideo() {
      this.$emit(
        "childToRoom",
        this.data.groupCode,
        false,
        this.data.synergyId
      );
    }
  }
};
</script>
  
  <style scoped lang="less">
.custom-template {
  width: 310px;
  padding: 12px;
  box-shadow: 0px 4px 8px 0px rgba(204, 204, 204, 0.2);
  border-radius: 6px;
  border: 2px solid #ffffff;
  .info-content {
    display: flex;
    justify-content: space-between;
    .left-img {
      width: 64px;
      height: 64px;
      border-radius: 8px;
    }
    .info-text {
      width: 205px;
      height: 40px;
      color: #333333;
      line-height: 20px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>